"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BODY_CATEGORY_KEY = 'base';
exports.BODY_PARENT_COMPONENT_KEY = 'table';
exports.BODY_COMPONENT_KEY = 'body';